import React, { Component } from 'react';
import {MasterLayout} from 'layout';
import {Link, browserHistory} from 'react-router';
import {Text} from 'components/tt-forms/common';
import {TrangChu} from 'api';
import moment from 'moment';
import {isEmpty} from 'lodash';

class NotificationDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
      ngayTao: ''
    }
  }

  onClickClose() {
    browserHistory.push('/thanh-tra/danh-sach-thong-bao');
  }

  componentWillMount() {
    if (this.props.params && this.props.params.id) {
      this.getThongBao(this.props.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const oldId = this.props.params && this.props.params.id;
    const newId = nextProps.params && nextProps.params.id;
    if (newId !== oldId) {
      this.getThongBao(newId);
    }
  }

  getThongBao(id) {
    TrangChu.actions.getChiTietThongBao.request({id:id}).then(res => {
      if (res.data) {
        this.setState({
          ...res.data
        });
      }
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center wrap-block">
          <div className="back-foward">
            <Link onClick={ this.onClickClose.bind(this) } title="">Về trang trước</Link>
          </div>
          <div className="heading">
            <h2 className="heading-title icon-add">
             Thông tin chi tiết thông báo
            </h2>
          </div>
          <div className="page-wrapper">
            <div className="group-box">
              <div className="items-form mb20">
                <div className="rows">
                  <Text label='Ngày thông báo:' className='col-20' value={this.state.ngayTao ? moment(this.state.ngayTao).format('DD/MM/YYYY') : ""}/>
                </div>
              </div>
              <div className="items-form mb20">
                <div className="rows">
                  <Text label='Nội dung thông báo:' className='col-60' value={this.state.content}/>
                </div>
              </div>
              {
                !isEmpty(this.state.typeDetail) && 
                <div className="items-form mb20">
                  <div className="rows">
                    <Text label='Nội dung đề xuất:' className='col-60' value={this.state.contentDetail}/>
                  </div>
                </div>
              }
              {
                !isEmpty(this.state.typeDetail) && 
                <div className="items-form mb20">
                  <div className="rows pl-5">
                    Vui lòng vào menu Thanh tra cập nhật để tránh chồng chéo.
                  </div>
                </div>
              }
            </div>
          </div>
          <div className="box-bottom ttt-bottom">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
          </div>
        </div>
      </MasterLayout>
    )
  }
}

export default NotificationDetails


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/NotificationDetails.jsx